var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307,
    height: 195,
    viewBox: "0 0 307 195",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.856 -311.245C343.856 -448.299 483.097 -325.86 535.467 -247.508C669.479 20.4431 284.876 292.184 94.6031 159.454C-95.6694 26.7239 33.3556 -139.927 205.856 -311.245Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector3.d78d85c563122b0f9e29ac2346d5f063.svg";
export { ForwardRef as ReactComponent };